import { SubrentalOutputDetailPrintModel } from "./subrental-output-detail-print.model";

export class SubrentalOutputPrintModel {
  inventoryOutputId: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  branchCode: string = '';
  branchName: string = '';
  address: string = '';
  phone: string = '';
  consecutive: string = '';
  dateOutput: Date = new Date();
  inventoryOutputStateId: number = 0;
  inventoryOutputState: string = '';
  deliveryDocument?: string = '';
  transporterName: string = '';
  vehicleName: string = '';
  plate: string = '';
  transportValue: number = 0;
  observation?: string = '';
  subrentalOutputDetails: SubrentalOutputDetailPrintModel[] = [];
}